import { render } from "./QuestionCard.vue?vue&type=template&id=18c5e22b"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"

import "./QuestionCard.vue?vue&type=style&index=0&id=18c5e22b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__